(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-content-article"] && !Shopify.designMode) return;
  try {
    
	function hydrateArticleVideos(root = document) {
		root.querySelectorAll('[data-content-body] .aspect-video').forEach((wrapper) => {
			if (wrapper.dataset.videoReady) return;
			const existing = wrapper.querySelector('iframe');
			const oldButton = wrapper.querySelector('button');
			const thumbnail = oldButton?.querySelector('img');
			const id = existing?.getAttribute('src')?.match(/youtube(?:-nocookie)?\.com\/embed\/([\w-]+)/)?.[1]
				|| thumbnail?.getAttribute('src')?.match(/ytimg\.com\/vi\/([\w-]+)/)?.[1];
			if (!id) return;
			wrapper.dataset.videoReady = 'true';
			const title = existing?.title || oldButton?.querySelector('span')?.textContent.trim() || '';
			const frame = existing || document.createElement('iframe');
			const src = existing?.getAttribute('src') || `https://www.youtube-nocookie.com/embed/${id}`;
			frame.removeAttribute('src');
			frame.title = title;
			frame.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
			frame.allowFullscreen = true;
			frame.referrerPolicy = 'strict-origin-when-cross-origin';
			const button = document.createElement('button');
			button.type = 'button';
			button.className = 'faq-video-preview';
			const label = wrapper.closest('[data-faq-video-label]')?.dataset.faqVideoLabel || 'Reproduzir vídeo';
			button.setAttribute('aria-label', `${label}: ${title}`);
			const img = document.createElement('img');
			img.src = `https://i.ytimg.com/vi/${id}/maxresdefault.jpg`;
			img.alt = '';
			img.loading = 'lazy';
			const titleLabel = document.createElement('span');
			titleLabel.className = 'faq-video-title';
			titleLabel.textContent = title;
			titleLabel.setAttribute('aria-hidden', 'true');
			const play = document.createElement('span');
			play.className = 'faq-video-play';
			play.setAttribute('aria-hidden', 'true');
			play.innerHTML = '<svg viewBox="0 0 68 48"><path d="M66.52 7.74c-.78-2.93-2.49-5.41-5.42-6.19C55.79.13 34 0 34 0S12.21.13 6.9 1.55C3.97 2.33 2.27 4.81 1.48 7.74C.06 13.05 0 24 0 24s.06 10.95 1.48 16.26c.79 2.93 2.49 5.41 5.42 6.19C12.21 47.87 34 48 34 48s21.79-.13 27.1-1.55c2.93-.78 4.64-3.26 5.42-6.19C67.94 34.95 68 24 68 24s-.06-10.95-1.48-16.26z"/><path d="M45 24 27 14 27 34" fill="#fff"/></svg>';
			button.append(img, titleLabel, play);
			button.addEventListener('click', () => {
				const url = new URL(src);
				url.searchParams.set('autoplay', '1');
				frame.src = url.href;
				button.replaceWith(frame);
				frame.focus();
			}, { once: true });
			wrapper.replaceChildren(button);
		});
	}
	hydrateArticleVideos();
	document.addEventListener('shopify:section:load', (event) => hydrateArticleVideos(event.target));

	function initializeEditorialToc(root) {
		if (root.dataset.tocReady === 'true') return;
		const body = root.querySelector('[data-content-body]');
		const toc = root.querySelector('[data-content-toc]');
		const list = root.querySelector('[data-content-toc-list]');
		if (!body || !toc || !list) return;

		const headings = Array.from(body.querySelectorAll('h2'));
		if (headings.length < 2) return;

		headings.forEach((heading, index) => {
			if (!heading.id) {
				const normalized = heading.textContent
					.normalize('NFD')
					.replace(/[\u0300-\u036f]/g, '')
					.toLowerCase()
					.replace(/[^a-z0-9]+/g, '-')
					.replace(/(^-|-$)/g, '');
				heading.id = normalized || `secao-${index + 1}`;
			}

			const item = document.createElement('li');
			const anchor = document.createElement('a');
			anchor.href = `#${heading.id}`;
			anchor.textContent = heading.textContent;
			item.append(anchor);
			list.append(item);
		});

		toc.hidden = false;
		root.dataset.tocReady = 'true';
	}

	function toggleEditorialPanel(trigger) {
		const root = trigger.closest('[data-content-article]');
		const panelId = trigger.getAttribute('aria-controls');
		if (!root || !panelId) return;
		const panel = Array.from(root.querySelectorAll('[data-editorial-panel]'))
			.find((candidate) => candidate.id === panelId);
		if (!panel) return;

		const opening = !panel.classList.contains('show');
		panel.classList.toggle('show', opening);
		panel.setAttribute('aria-hidden', String(!opening));
		trigger.setAttribute('aria-expanded', String(opening));
	}

	function initializeEditorialArticles(scope) {
		scope.querySelectorAll('[data-content-article]').forEach(initializeEditorialToc);
	}

	document.addEventListener('click', (event) => {
		const trigger = event.target.closest('[data-editorial-trigger]');
		if (trigger) toggleEditorialPanel(trigger);
	});

	document.addEventListener('keydown', (event) => {
		if (event.key !== 'Enter' && event.key !== ' ') return;
		const trigger = event.target.closest('[data-editorial-trigger]');
		if (!trigger) return;
		event.preventDefault();
		toggleEditorialPanel(trigger);
	});

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', () => initializeEditorialArticles(document));
	} else {
		initializeEditorialArticles(document);
	}

	document.addEventListener('shopify:section:load', (event) => {
		initializeEditorialArticles(event.target);
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-content-blog"] && !Shopify.designMode) return;
  try {
    
	document.querySelectorAll('[data-content-blog]').forEach((root) => {
		const search = root.querySelector('[data-content-blog-search]')
		const results = root.querySelector('[data-content-blog-results]')
		const articleLinks = Array.from(root.querySelectorAll('.content-blog__search-data a'))
		const normalize = (value) => String(value || '').toLocaleLowerCase('pt-BR').normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9\s/_-]/g, ' ').replace(/[/_-]+/g, ' ').replace(/\s+/g, ' ').trim()
		if (search && results) {
			search.addEventListener('input', () => {
				const query = normalize(search.value)
				results.replaceChildren()
				if (!query) {
					results.hidden = true
					return
				}

				const terms = query.split(' ')
				const articles = window.SterilairContentSearchIndex || articleLinks.map(link => ({ href: link.href, title: link.dataset.searchTitle, description: link.dataset.searchDescription }))
				const matches = articles.map(article => {
					const title = normalize(article.title)
					const description = normalize(article.description)
					const route = (article.searchPath || '').replace(/^\/saiba-mais\//, '')
					const text = normalize([article.title, article.description, route, ...(article.blocks || [])].join(' '))
					if (!terms.every(term => text.includes(term))) return null
					const block = (article.blocks || []).find(block => terms.every(term => normalize(block).includes(term))) || ''
					const score = (title.startsWith(query) ? 8 : 0) + (title.includes(query) ? 5 : 0) + (description.includes(query) ? 2 : 0) + (block ? 1 : 0) + terms.filter(term => title.includes(term)).length * 2 + terms.length
					return { ...article, score, snippet: block.length > 180 ? block.slice(0, 180).trimEnd() + '...' : block }
				}).filter(Boolean).sort((a, b) => b.score - a.score || a.title.localeCompare(b.title, 'pt-BR')).slice(0, 6)

				if (matches.length) {
					matches.forEach((source) => {
						const link = document.createElement('a')
						link.href = source.url || source.href
						const label = document.createElement('span')
						label.textContent = source.snippet ? root.dataset.indexedLabel : root.dataset.relatedLabel
						const title = document.createElement('h3')
						title.textContent = source.title
						const description = document.createElement('p')
						description.textContent = source.snippet || source.description || root.dataset.openLabel
						link.append(label, title, description)
						results.append(link)
					})
				} else {
					const empty = document.createElement('span')
					empty.className = 'content-blog__search-empty'
					empty.textContent = `${root.dataset.noResults} “${search.value.trim()}”.`
					results.append(empty)
				}
				results.hidden = false
			})
		}

		root.querySelectorAll('[data-content-blog-slider]').forEach((slider) => {
			const track = slider.querySelector('[data-content-blog-track]')
			const previous = slider.querySelector('[data-content-blog-previous]')
			const next = slider.querySelector('[data-content-blog-next]')
			if (!track || !previous || !next) return
			const move = (direction) => {
				const card = track.querySelector('.content-blog__card')
				if (!card) return
				const gap = Number.parseFloat(getComputedStyle(track).columnGap) || 0
				track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: 'smooth' })
			}
			previous.addEventListener('click', () => move(-1))
			next.addEventListener('click', () => move(1))
		})
	})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-content-page"] && !Shopify.designMode) return;
  try {
    
	function hydrateFaqVideos(root = document) {
		root.querySelectorAll('[data-faq-content] .aspect-video').forEach((wrapper) => {
			if (wrapper.dataset.videoReady) return;
			const existing = wrapper.querySelector('iframe');
			const oldButton = wrapper.querySelector('button');
			const thumbnail = oldButton?.querySelector('img');
			const id = existing?.getAttribute('src')?.match(/youtube(?:-nocookie)?\.com\/embed\/([\w-]+)/)?.[1]
				|| thumbnail?.getAttribute('src')?.match(/ytimg\.com\/vi\/([\w-]+)/)?.[1];
			if (!id) return;
			wrapper.dataset.videoReady = 'true';
			const title = existing?.title || oldButton?.querySelector('span')?.textContent.trim() || '';
			const frame = existing || document.createElement('iframe');
			const src = existing?.getAttribute('src') || `https://www.youtube-nocookie.com/embed/${id}`;
			frame.removeAttribute('src');
			frame.title = title;
			frame.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
			frame.allowFullscreen = true;
			frame.referrerPolicy = 'strict-origin-when-cross-origin';
			const button = document.createElement('button');
			button.type = 'button';
			button.className = 'faq-video-preview';
			button.setAttribute('aria-label', `${wrapper.closest('[data-faq-video-label]').dataset.faqVideoLabel}: ${title}`);
			const img = document.createElement('img');
			img.src = `https://i.ytimg.com/vi/${id}/maxresdefault.jpg`;
			img.alt = '';
			img.loading = 'lazy';
			const label = document.createElement('span');
			label.className = 'faq-video-title';
			label.textContent = title;
			label.setAttribute('aria-hidden', 'true');
			const play = document.createElement('span');
			play.className = 'faq-video-play';
			play.setAttribute('aria-hidden', 'true');
			play.innerHTML = '<svg viewBox="0 0 68 48"><path d="M66.52 7.74c-.78-2.93-2.49-5.41-5.42-6.19C55.79.13 34 0 34 0S12.21.13 6.9 1.55C3.97 2.33 2.27 4.81 1.48 7.74C.06 13.05 0 24 0 24s.06 10.95 1.48 16.26c.79 2.93 2.49 5.41 5.42 6.19C12.21 47.87 34 48 34 48s21.79-.13 27.1-1.55c2.93-.78 4.64-3.26 5.42-6.19C67.94 34.95 68 24 68 24s-.06-10.95-1.48-16.26z"/><path d="M45 24 27 14 27 34" fill="#fff"/></svg>';
			button.append(img, label, play);
			button.addEventListener('click', () => {
				const url = new URL(src);
				url.searchParams.set('autoplay', '1');
				frame.src = url.href;
				button.replaceWith(frame);
				frame.focus();
			}, { once: true });
			wrapper.replaceChildren(button);
		});
	}
	 hydrateFaqVideos();
	 document.addEventListener('shopify:section:load', (event) => hydrateFaqVideos(event.target));
	function hydrateFaqAssets(root = document) {
		const mapElement = root.querySelector('[data-faq-asset-map]') || document.querySelector('[data-faq-asset-map]');
		if (!mapElement) return;
		let assetMap;
		try {
			assetMap = JSON.parse(mapElement.textContent);
		} catch {
			return;
		}
		root.querySelectorAll('[data-faq-asset]').forEach((element) => {
			const url = assetMap[element.dataset.faqAsset];
			if (!url) return;
			if (element.tagName === 'SOURCE') element.srcset = url;
			else element.src = url;
		});
	}

	hydrateFaqAssets();
	document.addEventListener('shopify:section:load', (event) => hydrateFaqAssets(event.target));

	function toggleFaqEditorialPanel(trigger) {
		const root = trigger.closest('[data-faq-content]');
		const panelId = trigger.getAttribute('aria-controls');
		if (!root || !panelId) return;
		const panel = Array.from(root.querySelectorAll('[data-editorial-panel]'))
			.find((candidate) => candidate.id === panelId);
		if (!panel) return;
		const opening = !panel.classList.contains('show');
		panel.classList.toggle('show', opening);
		panel.setAttribute('aria-hidden', String(!opening));
		trigger.setAttribute('aria-expanded', String(opening));
	}

	document.addEventListener('click', (event) => {
		const trigger = event.target.closest('[data-faq-content] [data-editorial-trigger]');
		if (trigger) toggleFaqEditorialPanel(trigger);
	});

	document.addEventListener('keydown', (event) => {
		if (event.key !== 'Enter' && event.key !== ' ') return;
		const trigger = event.target.closest('[data-faq-content] [data-editorial-trigger]');
		if (!trigger) return;
		event.preventDefault();
		toggleFaqEditorialPanel(trigger);
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-purifier-benefits"] && !Shopify.designMode) return;
  try {
    
	function initializeProductBenefits(root) {
		root.querySelectorAll('[data-product-benefits] .product-benefits__coverage:not([data-coverage-ready])').forEach(function (coverage) {
			coverage.dataset.coverageReady = 'true'
			var button = coverage.querySelector('button')
			if (!button) return
			button.addEventListener('click', function () {
				var isOpen = coverage.classList.toggle('is-open')
				button.setAttribute('aria-expanded', String(isOpen))
			})
		})
	}

	initializeProductBenefits(document)
	document.addEventListener('shopify:section:load', function (event) {
		initializeProductBenefits(event.target)
	})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-purifier-main"] && !Shopify.designMode) return;
  try {
    
	function formatShippingDeliveryDate(value) {
		var date = new Date(value)
		if (isNaN(date.getTime())) return ''
		return date.toLocaleDateString('pt-BR', { timeZone: 'UTC', weekday: 'long', day: 'numeric', month: 'long' })
	}

	function escapeShippingHtml(value) {
		var node = document.createElement('div')
		node.textContent = value || ''
		return node.innerHTML
	}

	document.querySelectorAll('[data-purifier-product]').forEach(function (section) {
		var gallery = section.querySelector('[data-purifier-gallery]')
		if (gallery) {
			var mainImage = gallery.querySelector('[data-gallery-main]') || gallery.querySelector('.purifier-gallery__main img')
			var thumbnails = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-thumbnail]'))
			var currentIndex = Math.max(0, thumbnails.findIndex(function (thumbnail) { return thumbnail.classList.contains('is-active') }))
			var autoplayTimer
			var pointerStartX
			var animating = false
			var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches

			function showImage(index) {
				if (!mainImage || !thumbnails.length || animating) return
				var targetIndex = (index + thumbnails.length) % thumbnails.length
				if (targetIndex === currentIndex) return
				var direction = index < currentIndex ? -1 : 1
				var thumbnail = thumbnails[targetIndex]

				function updateState() {
					currentIndex = targetIndex
					mainImage.removeAttribute('srcset')
					mainImage.removeAttribute('sizes')
					mainImage.src = thumbnail.dataset.imageUrl
					mainImage.alt = thumbnail.dataset.imageAlt
					thumbnails.forEach(function (item, itemIndex) {
						item.classList.toggle('is-active', itemIndex === currentIndex)
						item.setAttribute('aria-current', itemIndex === currentIndex ? 'true' : 'false')
					})
				}

				if (reduceMotion || typeof mainImage.animate !== 'function') {
					updateState()
					return
				}

				animating = true
				var incoming = mainImage.cloneNode(false)
				incoming.removeAttribute('data-gallery-main')
				incoming.removeAttribute('srcset')
				incoming.removeAttribute('sizes')
				incoming.removeAttribute('fetchpriority')
				incoming.classList.add('purifier-gallery__incoming')
				incoming.src = thumbnail.dataset.imageUrl
				incoming.alt = thumbnail.dataset.imageAlt
				mainImage.parentElement.appendChild(incoming)

				var incomingStart = direction > 0 ? '100%' : '-100%'
				var outgoingEnd = direction > 0 ? '-100%' : '100%'
				var options = { duration: 350, easing: 'ease-in-out', fill: 'forwards' }

				function animateImages() {
					var outgoingAnimation = mainImage.animate([
						{ transform: 'translateX(0)' },
						{ transform: 'translateX(' + outgoingEnd + ')' }
					], options)
					var incomingAnimation = incoming.animate([
						{ transform: 'translateX(' + incomingStart + ')' },
						{ transform: 'translateX(0)' }
					], options)

					Promise.all([
						outgoingAnimation.finished.catch(function () {}),
						incomingAnimation.finished.catch(function () {})
					]).then(function () {
						updateState()
						outgoingAnimation.cancel()
						incomingAnimation.cancel()
						incoming.remove()
						animating = false
					})
				}

				if (typeof incoming.decode === 'function') {
					incoming.decode().catch(function () {}).then(animateImages)
				} else {
					animateImages()
				}
			}

			function stopAutoplay() {
				window.clearInterval(autoplayTimer)
			}

			function startAutoplay() {
				stopAutoplay()
				if (thumbnails.length > 1) {
					autoplayTimer = window.setInterval(function () { showImage(currentIndex + 1) }, 3000)
				}
			}

			function selectImage(index) {
				showImage(index)
				startAutoplay()
			}

			thumbnails.forEach(function (thumbnail, index) {
				thumbnail.addEventListener('click', function () { selectImage(index) })
			})

			var previous = gallery.querySelector('[data-gallery-previous]')
			var next = gallery.querySelector('[data-gallery-next]')
			if (previous) previous.addEventListener('click', function () { selectImage(currentIndex - 1) })
			if (next) next.addEventListener('click', function () { selectImage(currentIndex + 1) })

			var stage = gallery.querySelector('.purifier-gallery__stage')
			if (stage && thumbnails.length > 1) {
				stage.addEventListener('pointerdown', function (event) {
					if (!event.isPrimary) return
					if (event.target.closest('button, a, input, select')) return
					pointerStartX = event.clientX
					stage.setPointerCapture(event.pointerId)
				})
				stage.addEventListener('pointerup', function (event) {
					if (pointerStartX === undefined) return
					var distance = event.clientX - pointerStartX
					pointerStartX = undefined
					if (stage.hasPointerCapture(event.pointerId)) stage.releasePointerCapture(event.pointerId)
					if (Math.abs(distance) < 40) return
					selectImage(distance < 0 ? currentIndex + 1 : currentIndex - 1)
				})
				stage.addEventListener('pointercancel', function () { pointerStartX = undefined })
			}

			gallery.addEventListener('mouseenter', stopAutoplay)
			gallery.addEventListener('mouseleave', startAutoplay)
			gallery.addEventListener('focusin', stopAutoplay)
			gallery.addEventListener('focusout', startAutoplay)
			startAutoplay()
		}

		var variantSelector = section.querySelector('[data-variant-selector]')
		if (variantSelector) {
			variantSelector.addEventListener('change', function () {
				var selected = variantSelector.options[variantSelector.selectedIndex]
				var available = selected.dataset.available === 'true'
				section.querySelectorAll('[data-variant-id]').forEach(function (input) { input.value = selected.value })
				section.querySelectorAll('[data-product-price]').forEach(function (price) { price.textContent = selected.dataset.price })
				section.querySelectorAll('[data-product-list-price]').forEach(function (price) { price.textContent = selected.dataset.listPrice })
				section.querySelectorAll('[data-product-savings]').forEach(function (savings) {
					savings.textContent = selected.dataset.savings || ''
					savings.hidden = !selected.dataset.savings
				})
				section.querySelectorAll('.purifier-product-form button[type="submit"]').forEach(function (button) { button.disabled = !available })
			})
		}

		var postalCode = section.querySelector('[data-shipping-postal-code]')
		var shippingButton = section.querySelector('[data-shipping-submit]')
		var shippingMessage = section.querySelector('[data-shipping-message]')
		var shippingResults = section.querySelector('[data-shipping-results]')
		var shippingVariantInput = section.querySelector('.purifier-product-form [data-variant-id]')
		if (postalCode && shippingButton) {
			// PROD-01: rótulo orienta a digitar; com o CEP completo, vira a ação de calcular.
			var promptLabel = shippingButton.dataset.promptLabel || shippingButton.textContent.trim()
			var readyLabel = shippingButton.dataset.readyLabel || promptLabel
			postalCode.addEventListener('input', function () {
				var digits = postalCode.value.replace(/\D/g, '').slice(0, 8)
				postalCode.value = digits.length > 5 ? digits.slice(0, 5) + '-' + digits.slice(5) : digits
				var ready = digits.length === 8
				shippingButton.disabled = !ready
				shippingButton.textContent = ready ? readyLabel : promptLabel
				if (shippingMessage) shippingMessage.hidden = true
				if (shippingResults) shippingResults.hidden = true
			})
			shippingButton.addEventListener('click', function () {
				var estimator = window.SterilairShippingEstimate
				var variantId = shippingVariantInput && shippingVariantInput.value
				if (!estimator || !variantId) { if (shippingMessage) shippingMessage.hidden = false; return }

				if (shippingMessage) shippingMessage.hidden = true
				if (shippingResults) { shippingResults.hidden = false; shippingResults.textContent = 'Calculando…' }
				shippingButton.disabled = true

				estimator.estimateShipping(variantId, postalCode.value)
					.then(function (data) {
						var rates = data && data.shipping_rates
						if (!shippingResults) return
						if (!rates || !rates.length) {
							shippingResults.innerHTML = '<p class="purifier-shipping__error">Não encontramos opções de frete para esse CEP.</p>'
							return
						}
						shippingResults.innerHTML = rates.map(function (rate) {
							var estimate = formatShippingDeliveryDate(rate.delivery_date)
							return '<div class="purifier-shipping__rate">' +
								'<div class="purifier-shipping__rate-info"><strong>' + escapeShippingHtml(rate.name) + '</strong>' +
								(estimate ? '<span>Estimado: ' + estimate + '</span>' : '') + '</div>' +
								'<div class="purifier-shipping__rate-price">' + estimator.formatShippingPrice(rate.price) + '</div>' +
							'</div>'
						}).join('')
					})
					.catch(function () {
						if (shippingResults) shippingResults.hidden = true
						if (shippingMessage) shippingMessage.hidden = false
					})
					.finally(function () { shippingButton.disabled = false })
			})
		}

		section.querySelectorAll('[data-dialog-open]').forEach(function (button) {
			button.addEventListener('click', function () {
				var dialog = document.getElementById(button.dataset.dialogOpen)
				if (!dialog) return
				dialog.showModal()
				document.documentElement.classList.add('purifier-dialog-open')
			})
		})

		section.querySelectorAll('[data-dialog-close]').forEach(function (button) {
			button.addEventListener('click', function () {
				var dialog = button.closest('dialog')
				if (dialog) dialog.close()
			})
		})

		section.querySelectorAll('.purifier-dialog').forEach(function (dialog) {
			dialog.addEventListener('close', function () {
				document.documentElement.classList.remove('purifier-dialog-open')
			})

			dialog.addEventListener('click', function (event) {
				if (event.target !== dialog) return
				var bounds = dialog.getBoundingClientRect()
				var clickedBackdrop = event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom
				if (clickedBackdrop) dialog.close()
			})
		})
	})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-sono-bottom-offer"] && !Shopify.designMode) return;
  try {
    
	(function () {
		document.querySelectorAll('[data-sono-bottom-offer]').forEach(function (section) {
			var input = section.querySelector('[data-sono-bottom-postal]');
			var button = section.querySelector('[data-sono-bottom-calculate]');
			var message = section.querySelector('[data-sono-bottom-message]');
			var results = section.querySelector('[data-sono-bottom-results]');
			var wrapper = section.querySelector('.sono-bottom-offer__postal');
			var variantId = wrapper && wrapper.dataset.variantId;
			if (!input || !button) return;
			input.addEventListener('input', function () {
				var digits = input.value.replace(/\D/g, '').slice(0, 8);
				input.value = digits.length > 5 ? digits.slice(0, 5) + '-' + digits.slice(5) : digits;
				button.disabled = digits.length !== 8;
				button.textContent = digits.length ? (button.dataset.readyText || 'Calcular o frete') : (button.dataset.idleText || 'Digite o seu CEP');
				if (message) message.hidden = true;
				if (results) results.hidden = true;
			});
			button.addEventListener('click', function () {
				var estimator = window.SterilairShippingEstimate;
				if (!estimator || !variantId) { if (message) message.hidden = false; return; }

				if (message) message.hidden = true;
				if (results) { results.hidden = false; results.textContent = 'Calculando…'; }
				button.disabled = true;

				estimator.estimateShipping(variantId, input.value)
					.then(function (data) {
						var rates = data && data.shipping_rates;
						if (!results) return;
						if (!rates || !rates.length) {
							results.innerHTML = '<p class="sono-bottom-offer__shipping-error">Não encontramos opções de frete para esse CEP.</p>';
							return;
						}
						results.innerHTML = rates.map(function (rate) {
							return '<div class="sono-bottom-offer__shipping-rate"><span>' + rate.name + '</span><strong>' + estimator.formatShippingPrice(rate.price) + '</strong></div>';
						}).join('');
					})
					.catch(function () {
						if (results) results.hidden = true;
						if (message) message.hidden = false;
					})
					.finally(function () { button.disabled = false; });
			});
		});
	})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-sono-development"] && !Shopify.designMode) return;
  try {
    
	document.querySelectorAll('.sono-development__card[href^="#"]').forEach((link) => {
		if (link.dataset.anchorReady === 'true') return;
		link.dataset.anchorReady = 'true';

		link.addEventListener('click', (event) => {
			const targetId = link.getAttribute('href').slice(1);
			const target = document.getElementById(targetId);
			if (!target) return;

			event.preventDefault();
			const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
			target.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
			window.history.pushState(null, '', `#${targetId}`);
		});
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-sono-fold"] && !Shopify.designMode) return;
  try {
    
	(function () {
		document.querySelectorAll('[data-sono-product]').forEach(function (section) {
			var input = section.querySelector('[data-sono-postal-code]');
			var button = section.querySelector('[data-sono-shipping-button]');
			var message = section.querySelector('[data-sono-shipping-message]');
			var results = section.querySelector('[data-sono-shipping-results]');
			var variantId = section.querySelector('.sono-shipping') && section.querySelector('.sono-shipping').dataset.variantId;
			if (!input || !button) return;
			input.addEventListener('input', function () {
				var digits = input.value.replace(/\D/g, '').slice(0, 8);
				input.value = digits.length > 5 ? digits.slice(0, 5) + '-' + digits.slice(5) : digits;
				button.disabled = digits.length !== 8;
				button.textContent = digits.length ? (button.dataset.readyText || 'Calcular o frete') : (button.dataset.idleText || 'Digite o seu CEP');
				if (message) message.hidden = true;
				if (results) results.hidden = true;
			});
			button.addEventListener('click', function () {
				var estimator = window.SterilairShippingEstimate;
				if (!estimator || !variantId) { if (message) message.hidden = false; return; }

				if (message) message.hidden = true;
				if (results) { results.hidden = false; results.textContent = 'Calculando…'; }
				button.disabled = true;

				estimator.estimateShipping(variantId, input.value)
					.then(function (data) {
						var rates = data && data.shipping_rates;
						if (!results) return;
						if (!rates || !rates.length) {
							results.innerHTML = '<p class="sono-shipping__error">Não encontramos opções de frete para esse CEP.</p>';
							return;
						}
						results.innerHTML = rates.map(function (rate) {
							return '<div class="sono-shipping__rate"><span>' + rate.name + '</span><strong>' + estimator.formatShippingPrice(rate.price) + '</strong></div>';
						}).join('');
					})
					.catch(function () {
						if (results) results.hidden = true;
						if (message) message.hidden = false;
					})
					.finally(function () { button.disabled = false; });
			});
		});
	})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-sono-performance"] && !Shopify.designMode) return;
  try {
    
	(function () {
		function formatNumber(value) { return new Intl.NumberFormat('pt-BR').format(value); }
		function hydrate(root, summary) {
			var rating = Number(summary.aggregateRating || 0);
			var recommended = Math.round(Number(summary.recommendedPercentage || 0));
			var progress = Math.max(0, Math.min(100, recommended));
			root.querySelector('[data-konfidency-rating]').textContent = rating.toLocaleString('pt-BR', { minimumFractionDigits: 1, maximumFractionDigits: 1 });
			root.querySelector('[data-konfidency-count]').textContent = formatNumber(Number(summary.reviewCount || 0));
			root.querySelector('[data-konfidency-recommended]').textContent = recommended + '%';
			root.querySelectorAll('[data-konfidency-progress-rating]').forEach(function (item) { item.textContent = rating.toLocaleString('pt-BR', { minimumFractionDigits: 1, maximumFractionDigits: 1 }) + '/5'; });
			requestAnimationFrame(function () { root.querySelectorAll('[data-konfidency-progress]').forEach(function (bar) { bar.style.width = progress + '%'; }); });
		}
		document.querySelectorAll('[data-konfidency-resume]').forEach(function (root) {
			var url = root.dataset.apiUrl;
			if (!url) return;
			if (!window.__sterilairKonfidencySummaryPromise) {
				window.__sterilairKonfidencySummaryPromise = fetch(url).then(function (response) { if (!response.ok) throw new Error('Konfidency request failed'); return response.json(); }).then(function (data) { return data.reviews.summary; });
			}
			window.__sterilairKonfidencySummaryPromise.then(function (summary) { hydrate(root, summary); }).catch(function () { root.setAttribute('data-konfidency-error', 'true'); });
		});
	})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["purifier-testimonials"] && !Shopify.designMode) return;
  try {
    
	if (!customElements.get('purifier-testimonials-carousel')) {
		class PurifierTestimonialsCarousel extends HTMLElement {
			connectedCallback() {
				if (this.dataset.initialized === 'true') return
				this.dataset.initialized = 'true'

				var apiUrl = (this.dataset.apiUrl || '').replace(/\/$/, '').replace(/\/all-reviews(?:\?.*)?$/, '')
				if (!apiUrl) return

				var loading = this.querySelector('[data-testimonials-loading]')
				var track = this.querySelector('[data-testimonials-track]')
				var error = this.querySelector('[data-testimonials-error]')
				var template = this.querySelector('[data-testimonial-template]')
				loading.hidden = false

				fetch(apiUrl + '/store-reviews/carousel')
					.then(function (response) {
						if (!response.ok) throw new Error('Falha ao buscar o carrossel de avaliações')
						return response.json()
					})
					.then(function (payload) {
						var items = Array.isArray(payload) ? payload : (Array.isArray(payload && payload.value) ? payload.value : [])
						items = items.filter(function (item) {
							return item && ((item.text && item.text.trim()) || (item.name && item.name.trim()))
						})

						loading.hidden = true
						if (!items.length) return

						items.forEach(function (item) {
							var card = template.content.firstElementChild.cloneNode(true)
							var rawName = item.name && item.name.trim() ? item.name.trim() : 'Cliente Sterilair'
							var names = rawName.split(/\s+/)
							var formattedName = names.length === 1 ? names[0] : names[0] + ' ' + names[1].charAt(0).toUpperCase() + '.'
							var rating = Number(item.rating) || 5

							card.querySelector('[data-review-name]').textContent = formattedName
							card.querySelector('[data-review-text]').textContent = item.text && item.text.trim() ? item.text.trim() : 'Cliente avaliou mas não quis deixar comentários.'

							var ratingElement = card.querySelector('[data-review-rating]')
							ratingElement.setAttribute('aria-label', rating + ' de 5 estrelas')
							ratingElement.querySelectorAll('.icon-star').forEach(function (star, index) {
								var difference = rating - index
								if (difference <= 0) star.classList.add('is-empty')
								else if (difference < 1) star.classList.add('is-half')
							})

							if (item.created) {
								var date = new Date(item.created).toLocaleDateString('pt-BR', { timeZone: 'UTC' })
								card.querySelector('[data-review-date]').textContent = date
								card.querySelector('[data-review-date-wrap]').hidden = false
							}

							track.appendChild(card)
						})

						track.hidden = false
					})
					.catch(function () {
						loading.hidden = true
						error.hidden = false
					})
			}
		}

		customElements.define('purifier-testimonials-carousel', PurifierTestimonialsCarousel)
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["videos-library"] && !Shopify.designMode) return;
  try {
    
	function initializeVideoLibrary(root) {
		root.querySelectorAll('.videos-page__play:not([data-video-ready])').forEach(function (button) {
			button.dataset.videoReady = 'true'
			button.addEventListener('click', function () {
				var videoId = button.dataset.videoId
				var title = button.dataset.videoTitle
				if (!videoId) return

				var iframe = document.createElement('iframe')
				iframe.src = 'https://www.youtube.com/embed/' + encodeURIComponent(videoId) + '?showinfo=0&autoplay=1'
				iframe.title = title
				iframe.loading = 'lazy'
				iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
				iframe.referrerPolicy = 'strict-origin-when-cross-origin'
				button.replaceWith(iframe)
			})
		})
	}

	initializeVideoLibrary(document)
	document.addEventListener('shopify:section:load', function (event) {
		initializeVideoLibrary(event.target)
	})

  } catch(e) { console.error(e); }
})();
})();
